import { useEffect, useCallback } from 'react'
import { connect } from 'react-redux'
import { bool, func, arrayOf, string } from 'prop-types'

import { debugSettingsType } from 'models/propTypes'

import { getDebugSettings } from 'models/admin/selectors'
import { getIsAdmin, getCanBeAdmin } from 'models/user/selectors'
import { getSubCatalogs } from 'models/furniture/selectors'
import { updateDebugSettings, takeScreenshot, setAdmin } from 'models/admin/actions'
import { updateFurnitureFilter as updateFurnitureFilterAction } from 'models/furniture/actions'

const DebugHotkeysContainer = ({
    debugSettings,
    update,
    screenshot,
    isAdmin,
    canBeAdmin,
    changeAdmin,
    subCatalogs,
    updateFurnitureFilter,
}) => {
    const handleKeydown = useCallback(
        (event) => {
            // console.debug(event.keyCode)

            const updateSubCatalog = (index) => {
                event.stopPropagation()
                event.preventDefault()

                if (index <= 0) {
                    updateFurnitureFilter({ subCatalog: '*' })
                }
                if (subCatalogs && subCatalogs[index - 1]) {
                    updateFurnitureFilter({ subCatalog: subCatalogs[index - 1] })
                }
            }

            if (isAdmin) {
                switch (event.keyCode) {
                    case 65:
                        // char a
                        update({ useFancyShadows: !debugSettings.useFancyShadows })
                        break
                    case 68:
                        // char d
                        update({ frontSideShadows: !debugSettings.frontSideShadows })
                        break
                    case 71:
                        // char g
                        update({ linesViz: !debugSettings.linesViz })
                        break
                    case 72:
                        // char h
                        update({ highlightPlanes: !debugSettings.highlightPlanes })
                        break
                    case 77:
                        // char m
                        update({ showMemoryStats: !debugSettings.showMemoryStats })
                        break
                    case 78:
                        // char n
                        update({ nsViz: !debugSettings.nsViz })
                        break
                    case 79:
                        // char o
                        update({ hidePins: !debugSettings.hidePins })
                        break
                    case 80:
                        // char p
                        update({ showProductAdminData: !debugSettings.showProductAdminData })
                        break
                    case 81:
                        // char q
                        update({ enableGPUframetimeStats: !debugSettings.enableGPUframetimeStats })
                        break
                    case 82:
                        // char r
                        update({ canEditArtSize: !debugSettings.canEditArtSize })
                        break
                    case 83:
                        // char s
                        screenshot()
                        break
                    case 87:
                        // char w
                        update({ enableWalls: !debugSettings.enableWalls })
                        break
                    case 90:
                        // char z
                        update({ ssViz: !debugSettings.ssViz })
                        break
                    default:
                        break
                }
            }
            if (isAdmin || canBeAdmin) {
                if (event.metaKey || event.ctrlKey) {
                    switch (event.key) {
                        case '0':
                            updateSubCatalog(0)
                            break
                        case '1':
                            updateSubCatalog(1)
                            break
                        case '2':
                            updateSubCatalog(2)
                            break
                        case '3':
                            updateSubCatalog(3)
                            break
                        case '4':
                            updateSubCatalog(4)
                            break
                        case '5':
                            updateSubCatalog(5)
                            break
                        default:
                            break
                    }
                }
            }
            if (isAdmin || canBeAdmin) {
                switch (event.keyCode) {
                    case 74:
                        if (event.metaKey || event.ctrlKey) {
                            // ctrl + j
                            event.stopPropagation()
                            event.preventDefault()
                            changeAdmin(!isAdmin)
                        }
                        break
                    default:
                        break
                }
            }
        },
        [debugSettings, update, isAdmin, canBeAdmin, subCatalogs],
    )

    useEffect(() => {
        window.addEventListener('keydown', handleKeydown)
        return () => window.removeEventListener('keydown', handleKeydown)
    }, [handleKeydown])

    return null
}

DebugHotkeysContainer.defaultProps = {
    subCatalogs: null,
}

DebugHotkeysContainer.propTypes = {
    update: func.isRequired,
    debugSettings: debugSettingsType.isRequired,
    screenshot: func.isRequired,
    isAdmin: bool.isRequired,
    canBeAdmin: bool.isRequired,
    changeAdmin: func.isRequired,
    subCatalogs: arrayOf(string),
    updateFurnitureFilter: func.isRequired,
}

const mapStateToProps = (state) => ({
    debugSettings: getDebugSettings(state),
    isAdmin: getIsAdmin(state),
    canBeAdmin: getCanBeAdmin(state),
    subCatalogs: getSubCatalogs(state),
})

const mapDispatchToProps = {
    update: updateDebugSettings,
    screenshot: takeScreenshot,
    changeAdmin: setAdmin,
    updateFurnitureFilter: updateFurnitureFilterAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(DebugHotkeysContainer)
